import { render, staticRenderFns } from "./ItemListHistoryLink.vue?vue&type=template&id=2bd0f6ef&scoped=true"
import script from "./ItemListHistoryLink.vue?vue&type=script&lang=js"
export * from "./ItemListHistoryLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd0f6ef",
  null
  
)

export default component.exports